import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@store/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Optional permission required to access this route */
  permission?: string;
}

export const ProtectedRoute = ({ children, permission }: ProtectedRouteProps) => {
  const { isAuthenticated, user, hasCheKitPermission } = useAuthStore();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Must be Chekit staff to access internal portal
  if (!user.cheKitStaff) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600">This portal is for Chekit staff only.</p>
        </div>
      </div>
    );
  }

  // Optional route-level permission check
  if (permission && !hasCheKitPermission(permission)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Forbidden</h1>
          <p className="text-gray-600">You do not have the <code className="bg-gray-100 px-1 rounded">{permission}</code> permission.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
